import { StyleSheet } from 'react-native';
import { neutrals, alert, text } from 'src/theme/colors';

export const style = StyleSheet.create({
  leftAction: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
    justifyContent: 'flex-start',
  },
  leftActionIcon: {
    width: 22,
    height: 22,
    padding: 2,
  },
  iconBadge: {
    width: 12,
    height: 12,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: neutrals.white,
    position: 'absolute',
    right: -4,
    top: -2,
  },
  heartbeatBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: alert.variations.darkerAlertRed,
    borderRadius: 7,
    zIndex: 1,
  },
  leftActionText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: text.color.interactive,
  },
});
